import {combineReducers} from 'redux';

import report from '../common/ducks';
import qualTables, {NAME as QualTablesName} from '@/components/qual/Table/ducks';

export default combineReducers({
  report,
  [QualTablesName]: qualTables
});



// WEBPACK FOOTER //
// ./store/rootReducer.js